import { Permissoes } from './../../auth/permissoes';
import { BehaviorSubject } from 'rxjs';
import {Injectable} from '@angular/core';
import { MenuConfigService } from '../menu-config.service';
import * as objectPath from 'object-path';
import { LayoutConfigService } from '../layout-config.service';
import { AuthenticationService } from '../../auth/authentication.service';
import {ParametroDispositivoService, ParametroPortalService} from '../../../services';
import { AuthInfoService } from '../../../services/auth-info.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class MenuAsideService {
	classes: string;
	private menuList$ = new BehaviorSubject([]);

	isDropdown: number = 0;
	dropdownTimeout: number;
	isScrollable: number = 0;
	private utilizaMaxPag: boolean;

	constructor(
		private auth: AuthenticationService,
		private menuConfigService: MenuConfigService,
		private layoutConfigService: LayoutConfigService,
		private parametrService: ParametroDispositivoService,
		private parametroPortalService: ParametroPortalService,
		private authInfoService: AuthInfoService
	) {
		// get menu list
		this.menuConfigService.onMenuUpdated$.subscribe(model => {
			setTimeout(() => {
				this.validarExibicaoTorreControle();
				this.menuList$.next(objectPath.get(model.config, 'aside.items'));
				this.validarExibicaoMenuVisaoGerencial();
				this.validarExibicaoMenuMaxPag();
				this.validarExibicaoAbaRelatorios();
				this.validarExibicaoAbaWhatsapp();
				this.validarExibicaoMenuMaxInsights();
			});
		});


		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(config => {
			if (objectPath.get(config, 'config.aside.left.fixed')) {
				this.isScrollable = 1;
				this.isDropdown = 0;
			}

			if (!objectPath.get(config, 'config.aside.left.fixed')
				&& !objectPath.get(config, 'config.menu.aside.desktop_and_mobile.submenu.accordion')) {
				this.isScrollable = 0;
				this.isDropdown = 1;
				this.dropdownTimeout = objectPath.get(config, 'config.menu.aside.desktop_and_mobile.submenu.dropdown.hover_timeout');
			}
		});
	}


	async validarExibicaoMenuMaxPag() {
		this.utilizaMaxPag = await this.verificarUtilizaMaxPag();

			const indiceMenuCadastro = this.menuList$.value.findIndex(menu => menu.title === 'Cadastros');
			if (indiceMenuCadastro !== -1) {
				const indiceSubMenu = this.menuList$.value[indiceMenuCadastro].submenu
					.findIndex(submenu => submenu.page === '/pages/cadastros/max-pag');
				if (indiceSubMenu !== -1 && !this.utilizaMaxPag) {
					this.menuList$.value[indiceMenuCadastro].submenu[indiceSubMenu].page = '';
					this.menuList$.value[indiceMenuCadastro].submenu[indiceSubMenu].dialog = true;
				}
			}
			this.atualizarMenuList();
	}

	async validarExibicaoMenuMaxInsights() {
		const indiceMenuCadastro = this.menuList$.value.findIndex(menu => menu.title === 'MaxInsights');
	
		const ofertas = await this.authInfoService.getOfertasPorCliente("21").toPromise();
	
		if(!ofertas || ofertas.length === 0) {
		  return;
		}
	
		if(ofertas[0].status === 'L') {
		  this.menuList$.value[indiceMenuCadastro].dialog = false;
		  this.menuList$.value[indiceMenuCadastro].msgSemAcesso = 'No momento, você não possui uma licença disponível para acessar o MaxInsights.';
		  this.atualizarMenuList();
		}
	
		if(ofertas[0].status != 'A') {
		  return;
		}
	
		this.menuList$.value[indiceMenuCadastro].page = `${environment.maxInsightsUrl}/?PWE=${this.auth.obtenhaToken()}`;
		this.menuList$.value[indiceMenuCadastro].dialog = false;
		this.atualizarMenuList();
	  }

	async validarExibicaoAbaRelatorios() {
		const podeVerAbaRelatorios = await this.auth.usuarioTemPermissaoNaRota(Permissoes.RELATORIOS.getValor());

		if (podeVerAbaRelatorios) {
			return;
		}

		const indiceMenuRelatorios = this.menuList$.value.findIndex(menu => menu.title === 'Relatórios');

		if (indiceMenuRelatorios === -1) {
			return;
		}

		this.menuList$.value.splice(indiceMenuRelatorios, 1);
		this.atualizarMenuList();
	}

	validarExibicaoMenuVisaoGerencial() {
		if (!this.auth.usuarioTemPermissaoNaRota(Permissoes.CADASTRO_VISAO_GERENCIAL.getValor())) {
			const indiceMenuCadastro = this.menuList$.value.findIndex(menu => menu.title === 'Cadastros');
			if (indiceMenuCadastro !== -1) {
				const indiceSubMenu = this.menuList$.value[indiceMenuCadastro].submenu
					.findIndex(submenu => submenu.page === '/pages/cadastros/visao-painel');
				if (indiceSubMenu !== -1) {
					this.menuList$.value[indiceMenuCadastro].submenu.splice(indiceSubMenu, 1);
					this.atualizarMenuList();
				}
			}
		}
	}

	async validarExibicaoTorreControle() {
		const paramVisualizaRomaneio = await this.parametrService.visualizacaoRomaneioApk().toPromise();

		if (paramVisualizaRomaneio.valor === 'S') {
			return;
		}

		const indiceMenuRelatorios = this.menuList$.value.findIndex(menu => menu.title === 'Torre de Controle Logístico');

		if (indiceMenuRelatorios === -1) {
			return;
		}

		this.menuList$.value.splice(indiceMenuRelatorios, 1);
		this.atualizarMenuList();
	}

	private async verificarUtilizaMaxPag() {
		const param = await this.parametrService.utilizaMaxPag().toPromise();
		return param.valor === 'S';
	}

	private validarExibicaoAbaWhatsapp() {
		this.parametroPortalService
			.obterParametroPorTipos('TRABALHAR_INTEGRACAO_WHATSAPP')
			.subscribe(([parametro]) => {
				if (!parametro || !parametro.valorBoleano) return;

				const indiceMenuConfiguracoes = this.menuList$.value.findIndex(menu => menu.title === 'Configurações');

				const indiceMenuWhatsapp = this.menuList$.value[indiceMenuConfiguracoes].submenu
					.findIndex(submenu => submenu.title === 'Whatsapp');

				this.menuList$.value[indiceMenuConfiguracoes].submenu[indiceMenuWhatsapp].msgSemAcesso = ''
				this.atualizarMenuList();
			})
	}

	atualizarMenuList() {
		this.menuList$.next(this.menuList$.value);
	}

	getMenuListAsObservable() {
		return this.menuList$.asObservable();
	}

	getMenuList() {
		return this.menuList$.getValue();
	}

}
